<template>
  <svg width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor"/>
    <circle cx="8.5" cy="1.5" r="1.5" fill="currentColor"/>
    <circle cx="15.5" cy="1.5" r="1.5" fill="currentColor"/>
  </svg>
</template>